import type { ApiClient } from '../client';
import { MeResponseSchema, type MeResponse } from '../schemas/me';

// The effective permissions and role names of whoever holds the token. Parsed at the boundary, so a
// payload the panel cannot read rejects (and grants nothing) instead of flowing in untyped.
export async function getMe(client: ApiClient): Promise<MeResponse> {
  const data = await client.get<unknown>('/app_service/panel/v1/me');
  return MeResponseSchema.parse(data);
}
